export const INVITATION_EVENT_LIST_REQUEST = 'INVITATION_EVENT_LIST_REQUEST';

export const INVITATION_EVENT_LIST = 'INVITATION_EVENT_LIST';

export const INVITATION_EVENT_RESPONSE_MESSAGE = 'INVITATION_EVENT_RESPONSE_MESSAGE';

export const INVITATION_EVENT_CREATE_REQUEST = 'INVITATION_EVENT_CREATE_REQUEST';

export const INVITATION_EVENT_INFO_DETAILS_REQUEST = 'INVITATION_EVENT_INFO_DETAILS_REQUEST';

export const INVITATION_EVENT_INFO_HISTORY_REQUEST = 'INVITATION_EVENT_INFO_HISTORY_REQUEST';

export const INVITATION_EVENT_INFO_REWARD_REQUEST = 'INVITATION_EVENT_INFO_REWARD_REQUEST';

export const INVITATION_EVENT_INFO_DETAILS = 'INVITATION_EVENT_INFO_DETAILS';

export const INVITATION_EVENT_INFO_UPDATE_REQUEST = 'INVITATION_EVENT_INFO_UPDATE_REQUEST';

export const INVITATION_EVENT_INFO_DELETE_REQUEST = 'INVITATION_EVENT_INFO_DELETE_REQUEST';

export const SET_TOTAL_COUNT = 'SET_TOTAL_COUNT';

export const SET_INVITATION_EVENT_PAGINATION = 'SET_INVITATION_EVENT_PAGINATION';

export const INVITATION_EVENT_PAGE_RESET = 'INVITATION_EVENT_PAGE_RESET';

export const INVITATION_EVENT_DEPOSIT_REQUEST = 'INVITATION_EVENT_DEPOSIT_REQUEST';

export const INVITATION_EVENT_ADD_BUDGET = 'INVITATION_EVENT_ADD_BUDGET';
